import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScoreChartBg = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	width: 276,
	height: 200,
	viewBox: "0 0 276 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "aura-scan-chart-bg",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 276,
			height: 200,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 276,
				height: 200,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#aura-scan-chart-bg)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 138,
				cy: 138,
				r: 137.225,
				stroke: "url(#aura-scan-chart-deco)",
				strokeWidth: 1.55
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "aura-scan-chart-deco",
			x1: 138,
			y1: 0,
			x2: 138,
			y2: 190,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				stopColor: "#DFCBF5",
				stopOpacity: .7
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#DFCBF5",
				stopOpacity: 0
			})]
		}) })
	]
});
export default SvgScoreChartBg;
